<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>Create supplier</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-3">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="vendor.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100" autofocus/>
              </v-col>
            </v-row>
            <v-row dense v-if="multiCurrency">
              <v-col cols="4">
                <v-autocomplete v-model="vendor.currency" outlined dense label="Currency"
                                :items="currencies" item-text="code" item-value="code"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col>
                <v-checkbox v-model="vendor.suppliesInBond" dense label="Supplies alcohol in-bond" class="mt-0"/>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field v-if="vendor.suppliesInBond" v-model="vendor.license" outlined dense label="License number" :rules="[fieldRules.maxLength(20)]" :counter="20"/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'SupplierQuickCreate',
	props: {
    value: {type:Boolean,required:true},
    suppliesInBond: {type:Boolean, required:false, default:false},
    defaultName: {type:String, required:false, default:''}
  },
  data() {
    return {
      valid: true,
      show: false,
      currencies: [],
      vendor: {name:'',currency:'',active:true,suppliesInBond:this.suppliesInBond,license:''},
      busy: false
    }
  },
  computed: {
    multiCurrency() {
      return this.$store.getters.company.settings.multiCurrency;
    }
  },
 async created() {
   if (this.multiCurrency) {
      const results = await this.$apiCall(`query SupplierQuickCreate {
                                            company {currencies {code}}
                                          }`,
                                          {});
      if (!results.error)
        this.currencies = [{code:this.$store.getters.company.settings.homeCurrency}].concat(results.data.company.currencies);
   }
  },
  watch: {
    value() {
      this.vendor.name = this.defaultName;
      this.vendor.currency = this.$store.getters.company.settings.homeCurrency;
      this.show = this.value;
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation SupplierQuickCreate($input: VendorInput!) {
                                            vendorCreate(input:$input) {
                                              id,name,currency,email,suppliesInBond,license,
                                              billingAddress{line1,line2,city,province,postalCode}
                                            }
                                          }`,
                                          {input:this.vendor});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.vendorCreate);
      }
    },
  }
}
</script>
